import type { AlertDisposition } from '@/types/domain';
import { apiFetch, withQuery } from '@/app/apiClient';

import {
  ALERTS_ENDPOINTS,
  type AlertDetail,
  type AlertRow,
  type AlertsApi,
  type SupportingTransaction,
} from './api';

/**
 * Real HTTP client for the Live alerts feed screen. Filters map 1:1 onto
 * `/api/v1/alerts` query parameters; the detail view lazy-loads via
 * `/api/v1/alerts/:id`. `patchDisposition` PATCHes the alert with the
 * analyst's verdict + free-text reason so the audit trail captures the
 * "why" along with the disposition change.
 */
export function createFetchAlertsApi(): AlertsApi {
  return {
    listAlerts: async (query) =>
      apiFetch<AlertRow[]>(
        withQuery(ALERTS_ENDPOINTS.list, {
          disposition: query.disposition,
          scenarioId: query.scenarioId as string | undefined,
          sourcePlatform: query.sourcePlatform,
          alertClass: query.alertClass,
          groupingKey: query.groupingKey,
        }),
      ),
    getAlert: async (id) =>
      apiFetch<AlertDetail | null>(
        ALERTS_ENDPOINTS.byId(encodeURIComponent(id as unknown as string)),
      ),
    listTransactions: async (id) =>
      apiFetch<SupportingTransaction[]>(
        ALERTS_ENDPOINTS.transactions(encodeURIComponent(id as unknown as string)),
      ),
    patchDisposition: async (id, input) =>
      apiFetch<{ alertId: string; disposition: AlertDisposition; setAt: string }>(
        ALERTS_ENDPOINTS.disposition(encodeURIComponent(id as unknown as string)),
        {
          method: 'PATCH',
          body: JSON.stringify(input),
        },
      ),
  };
}
